export default __webpack_public_path__ + "static/tab-img-4cced00def6c5fd47c3d41dcd669ed13.png";